import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar, { ScrollIndicator } from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://bum-desa-warga-dekat-bandung-production.up.railway.app";

const IMAGES = {
  heroBg: "/images/imageweb_1.jpg",
  fallbackCard: "/images/news-placeholder.jpg",
};

function formatTanggalIndonesia(dateString) {
  if (!dateString) return "Tanggal belum tersedia";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Tanggal belum tersedia";

  return date.toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export default function News({ isAdmin, AdminSection }) {
  const navigate = useNavigate();
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/news`);
        const data = await res.json();

        console.log("PUBLIC NEWS RESPONSE:", data);

        let result = [];
        if (Array.isArray(data)) {
          result = data;
        } else if (Array.isArray(data.data)) {
          result = data.data;
        } else if (Array.isArray(data.news)) {
          result = data.news;
        }

        setNewsList(result);
      } catch (err) {
        console.error("Gagal ambil berita:", err);
        setNewsList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="min-h-screen bg-white font-serif page-transition">
      <style>{`
        .page-hero {
          height: 420px;
          min-height: 320px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          background-size: cover;
          background-position: center;
          overflow: hidden;
        }

        .page-hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            160deg,
            rgba(20,40,28,0.75) 0%,
            rgba(61,79,69,0.52) 60%,
            rgba(15,30,20,0.82) 100%
          );
        }

        .page-hero-content {
          position: relative;
          z-index: 10;
          text-align: center;
          padding: 64px 1.5rem 0;
          animation: pgFadeUp 0.9s ease 0.15s both;
        }

        @keyframes pgFadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .card-wrap-hover .card-img {
          transition: transform .45s ease;
        }

        .card-wrap-hover:hover .card-img {
          transform: scale(1.05);
        }

        .news-card {
          background: white;
          border-radius: 18px;
          overflow: hidden;
          border: 1px solid #eef2ef;
          box-shadow: 0 10px 30px rgba(24, 39, 29, 0.06);
          transition: all .3s ease;
        }

        .news-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 16px 40px rgba(24, 39, 29, 0.12);
        }
      `}</style>

      <Navbar />
      <WhatsAppButton />

      <section
        className="page-hero"
        style={{ backgroundImage: `url(${IMAGES.heroBg})` }}
      >
        <div className="page-hero-overlay" />

        <div className="page-hero-content">
          <p
            style={{
              fontSize: ".62rem",
              letterSpacing: ".32em",
              color: "#d7e0d8",
              textTransform: "uppercase",
              marginBottom: "1rem",
            }}
          >
            BUM Desa Warga Dekat Bandung
          </p>

          <h1
            style={{
              fontSize: "clamp(2rem,4.5vw,3.4rem)",
              color: "#fff",
              fontWeight: 300,
              lineHeight: 1.18,
              marginBottom: "1rem",
            }}
          >
            Berita & Artikel
          </h1>

          <p
            style={{
              fontSize: ".92rem",
              color: "rgba(255,255,255,.85)",
              maxWidth: "560px",
              margin: "0 auto",
              lineHeight: 1.8,
            }}
          >
            Informasi terkini, pencapaian, dan cerita inspiratif dari BUM Desa
            Warga Dekat Bandung.
          </p>
        </div>

        <ScrollIndicator targetId="news-section" />
      </section>

      <section id="news-section" className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl text-center mb-2 text-[#3d4f45] font-light">
            Berita Terkini
          </h2>
          <p className="text-center text-gray-500 text-sm mb-14">
            Kabar terbaru dari desa kami untuk Anda.
          </p>

          {loading ? (
            <p className="text-center text-gray-500">Loading berita...</p>
          ) : newsList.length === 0 ? (
            <p className="text-center text-gray-500">Berita belum tersedia.</p>
          ) : (
            <div
              className={`grid gap-8 ${
                newsList.length === 1
                  ? "grid-cols-1 max-w-md mx-auto"
                  : newsList.length === 2
                    ? "grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto"
                    : "grid-cols-1 md:grid-cols-2 xl:grid-cols-3"
              }`}
            >
              {newsList.map((n) => (
                <div
                  key={n.id}
                  className="news-card cursor-pointer card-wrap-hover"
                  onClick={() => navigate(`/news/${n.slug || n.id}`)}
                >
                  <div className="relative h-56 overflow-hidden bg-[#d9e2db]">
                    <img
                      src={n.cover_url || IMAGES.fallbackCard}
                      alt=""
                      className="card-img w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = IMAGES.heroBg;
                      }}
                    />

                    <div className="absolute top-4 left-4">
                      <span className="text-[11px] bg-white/90 text-[#3d4f45] px-3 py-1 rounded-full shadow-sm">
                        Berita
                      </span>
                    </div>
                  </div>

                  <div className="p-6">
                    <p className="text-xs text-gray-400 mb-3">
                      {formatTanggalIndonesia(n.published_at)}
                    </p>

                    <h3 className="text-lg font-semibold mb-3 text-[#3d4f45] leading-snug line-clamp-2">
                      {n.title || "Tanpa Judul"}
                    </h3>

                    <p className="text-gray-500 text-sm leading-relaxed mb-5 line-clamp-3 min-h-[72px]">
                      {n.summary || "Ringkasan berita belum tersedia."}
                    </p>

                    <span className="text-sm text-[#3d4f45] font-medium hover:underline">
                      Baca Selengkapnya →
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && newsList.length > 3 && (
            <div className="text-center mt-14">
              <button className="bg-[#3d4f45] text-white px-8 py-3 rounded-full text-xs tracking-wider hover:bg-[#4a5a50] transition">
                MUAT LEBIH BANYAK
              </button>
            </div>
          )}
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-6 pb-8">
        <hr className="my-8 border-gray-200" />
        <AdminSection />
      </div>

      <Footer />
    </div>
  );
}
